import { createRelayResource, RelayResourceConfig } from '@townsquare/relay-utils';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
} from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import PeopleDirectoryViewQuery, {
	type PeopleDirectoryViewQuery as PeopleDirectoryViewQueryType,
} from '../components/__generated__/PeopleDirectoryViewQuery.graphql';

export const getPeopleDirectoryResourceQuery = (
	routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<PeopleDirectoryViewQueryType> => {
	const context = resourceContext as HomeResourceContext;

	return {
		query: PeopleDirectoryViewQuery,
		variables: {
			organisationId: context.workspace?.organisationId ?? context.orgId ?? '',
			cloudId: (context.collabContext?.rovoWorkspace || context.workspace?.cloudId) ?? 'None',
			skipOldCheck: fg('fix-people-teams-directory-existence-check'),
		},
	};
};

export const peopleDirectoryResource = createRelayResource<PeopleDirectoryViewQueryType>({
	getQuery: getPeopleDirectoryResourceQuery,
});
